import { createFileRoute } from '@tanstack/react-router'
import TermsPage from '@/pages/terms'
import { buildHead } from '@/shared/seo/seo-config'

export const Route = createFileRoute('/$lang/terms')({
  head: ({ params }) => buildHead('terms', params.lang),
  component: TermsPage,
  staticData: { layout: 'public' },
})
